/**
 * @generated SignedSource<<f9ac0796c9cf79b73049c0b4fb6468aa>>
 * @relayHash 8ecba969439d16d294ced36ddd9addd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74c63e963e34a5e0af800ad1ad0509e907e61d19edf4b1a0dc3ba6ffc26e18c5

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tabs_jwmNavigationItemsQuery$variables = {
  cloudId: string;
  first: number;
  projectIdOrKey: string;
};
export type tabs_jwmNavigationItemsQuery$data = {
  readonly jira: {
    readonly navigationItems: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraNavigationItemEdge";
      } | null | undefined> | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly extensions: ReadonlyArray<{
          readonly statusCode: number | null | undefined;
        }> | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabList_TabList">;
    };
  };
};
export type tabs_jwmNavigationItemsQuery = {
  response: tabs_jwmNavigationItemsQuery$data;
  variables: tabs_jwmNavigationItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "kind": "Variable",
  "name": "projectIdOrKey",
  "variableName": "projectIdOrKey"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v7 = {
  "kind": "ScalarField",
  "name": "message"
},
v8 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v9 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v10 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v4/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "label"
},
v12 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v13 = {
  "kind": "ScalarField",
  "name": "url"
},
v14 = {
  "kind": "ScalarField",
  "name": "styleClass"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "tabs_jwmNavigationItemsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "navigationItems",
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "concreteType": "JiraNavigationItemConnection",
                "kind": "LinkedField",
                "name": "__tabs_jiraNavigation__navigationItems_connection",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ui_navigationKitTabList_TabList"
                  },
                  {
                    "concreteType": "JiraNavigationItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.navigationItems"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "tabs_jwmNavigationItemsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "navigationItems",
            "args": (v10/*: any*/),
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "jwmSavedViewsByProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraNavigationItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isDefault"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeKey"
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isJiraNavigationItem"
                      },
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "canRemove"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canSetAsDefault"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "concreteType": "JiraAppNavigationItemNestedLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v13/*: any*/),
                          (v12/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "envLabel"
                          }
                        ],
                        "type": "JiraAppNavigationItem"
                      }
                    ]
                  },
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              },
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              (v9/*: any*/)
            ]
          },
          {
            "alias": "navigationItems",
            "args": (v10/*: any*/),
            "filters": [
              "cloudId",
              "projectIdOrKey"
            ],
            "handle": "connection",
            "key": "tabs_jiraNavigation__navigationItems",
            "kind": "LinkedHandle",
            "name": "jwmSavedViewsByProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "74c63e963e34a5e0af800ad1ad0509e907e61d19edf4b1a0dc3ba6ffc26e18c5",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "navigationItems"
          ]
        }
      ]
    },
    "name": "tabs_jwmNavigationItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2d84b9ec639958d8e958f01bde5a1fea";

export default node;
